import PropTypes from "prop-types";
import "./filterSidebar.scss";
import { useGetCategoriesQuery } from "../api/videoCategoriesApiSlice";
import { useMemo } from "react";
// import useAuth from "../../hooks/useAuth";

const FilterComponent = ({
  videoType,
  category,
  handleFilterChange,
  mobileFilter,
  toggleMobileFilterMenu,
  videos,
}) => {
  // const { isLoggedIn } = useAuth();
  const { data: categories = [], isLoading } = useGetCategoriesQuery();

  // Filter only categories that actually have videos
  const categoriesWithVideos = categories.filter((cat) =>
    videos?.some((v) => v.categories?.some((c) => c._id === cat._id))
  );

  return (
    <div className={`filter-component ${mobileFilter ? "show" : ""}`}>
      {mobileFilter && (
        <button className="close-filter" onClick={toggleMobileFilterMenu}>
          ✕
        </button>
      )}

      {isLoading ? (
        <p>Loading filters...</p>
      ) : (
        <>
          {/* Video Type List */}
          <div className="filter-item list-filter">
            <label>Video Type:</label>
            <div className="filter-list">
              {["", "free Videos", "Member Videos"].map((type) => (
                <button
                  key={type || "all"}
                  className={`filter-btn ${videoType === type ? "active" : ""}`}
                  onClick={() => handleFilterChange({ videoType: type })}
                >
                  {type === ""
                    ? "All"
                    : type.charAt(0).toUpperCase() + type.slice(1)}
                </button>
              ))}
            </div>
          </div>

          {/* Category List */}
          <div className="filter-item list-filter">
            <label>Category:</label>
            <div className="filter-list scrollable">
              <button
                className={`filter-btn ${!category ? "active" : ""}`}
                onClick={() => handleFilterChange({ category: "" })}
              >
                All
              </button>
              <button
                className={`filter-btn most-viewed ${
                  category === "most-viewed" ? "active" : ""
                }`}
                onClick={() => handleFilterChange({ category: "most-viewed" })}
              >
                Most Viewed
              </button>
              {categoriesWithVideos.map((cat) => (
                <button
                  key={cat._id}
                  className={`filter-btn ${
                    category === cat._id ? "active" : ""
                  }`}
                  onClick={() => handleFilterChange({ category: cat._id })}
                >
                  {cat.name}
                </button>
              ))}
            </div>
          </div>
        </>
      )}
      {/* {!isLoggedIn && <SubscriptionEmail />} */}
    </div>
  );
};

FilterComponent.propTypes = {
  setVideoType: PropTypes.func.isRequired,
  handleFilterChange: PropTypes.func.isRequired,
  videoType: PropTypes.string.isRequired,
  videos: PropTypes.arrayOf(PropTypes.object),
  category: PropTypes.string,
  toggleMobileFilterMenu: PropTypes.func.isRequired,
  mobileFilter: PropTypes.bool.isRequired,
};

export default FilterComponent;
